<template>
    <div class="form-group">
        <FormLabel :required="required">{{ label }}</FormLabel>
        <div class="flex-1">
            <FormInput
                :class="inputClass ? inputClass : 'w-full'" :options="options"
                :autocomplete="autocomplete" :half-width="halfWidth" :placeholder="placeholder"
                :type="type" :value="value" @input="v => $emit('input', v)"/>
            <ErrorText :name="name" :errors="errors"/>
            <div class="text-main-color mt-2"
                 v-if="helpText || $slots['helpText']">
                {{ helpText }}
                <slot name="helpText"></slot>
            </div>
        </div>
    </div>
</template>

<script>
import FormLabel from "./FormLabel";
import FormInput from "../app/FormInput";
import ErrorText from "../ErrorText";

export default {
    name: "FormGroup",
    components: {ErrorText, FormInput, FormLabel},
    props: {
        name: {
            type: String,
            required: true
        },
        label: {
            type: String,
            required: true,
        },
        value: {
            type: String | Number | Boolean,
        },
        placeholder: {
            type: String,
        },
        type: {
            type: String,
            default: 'text'
        },
        errors: {
            type: Object | Array
        },
        inputClass: {
            type: String,
        },
        autocomplete: {
            type: String
        },
        options: {
            type: Array
        },
        required: {
            type: Boolean,
            default: false
        },
        halfWidth: {
            type: Boolean,
            default: false,
        },
        helpText: {
            type: String
        }
    }
}
</script>

<style scoped>
</style>
